/**
 * CoLab Button Effects Module
 * Ефект кружка що слідує за курсором + ripple при кліку
 */

export const ButtonEffects = {
    buttons: null,

    init: function() {
        this.buttons = document.querySelectorAll('.button--primary, .button--secondary');

        if (!this.buttons.length) return;

        this.bindEvents();
        console.log('[CoLab.ButtonEffects] Initialized on', this.buttons.length, 'buttons');
    },

    bindEvents: function() {
        var self = this;

        this.buttons.forEach(function(button) {
            // Створюємо елементи для ефектів
            self.setupButton(button);

            // Mouse enter - показуємо курсор
            button.addEventListener('mouseenter', function(e) {
                self.showCursor(button);
                self.moveCursor(button, e);
            });

            // Mouse move - рухаємо курсор
            button.addEventListener('mousemove', function(e) {
                self.moveCursor(button, e);
            });

            // Mouse leave - ховаємо курсор
            button.addEventListener('mouseleave', function() {
                self.hideCursor(button);
            });

            // Click - ripple ефект
            button.addEventListener('click', function(e) {
                self.createRipple(button, e);
            });
        });
    },

    setupButton: function(button) {
        // Додаємо клас для стилізації
        button.classList.add('has-cursor-effect');

        // Створюємо контейнер для ефектів
        var effectsContainer = document.createElement('span');
        effectsContainer.className = 'button__effects';

        // Створюємо курсор-кружок
        var cursor = document.createElement('span');
        cursor.className = 'button__cursor';

        // Контейнер для ripple
        var rippleContainer = document.createElement('span');
        rippleContainer.className = 'button__ripples';

        effectsContainer.appendChild(cursor);
        effectsContainer.appendChild(rippleContainer);
        button.appendChild(effectsContainer);
    },

    moveCursor: function(button, e) {
        var cursor = button.querySelector('.button__cursor');
        if (!cursor) return;

        var rect = button.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
    },

    showCursor: function(button) {
        var cursor = button.querySelector('.button__cursor');
        if (cursor) {
            cursor.classList.add('is-visible');
        }
    },

    hideCursor: function(button) {
        var cursor = button.querySelector('.button__cursor');
        if (cursor) {
            cursor.classList.remove('is-visible');
        }
    },

    createRipple: function(button, e) {
        var rippleContainer = button.querySelector('.button__ripples');
        if (!rippleContainer) return;

        var rect = button.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        // Створюємо ripple елемент
        var ripple = document.createElement('span');
        ripple.className = 'button__ripple';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';

        rippleContainer.appendChild(ripple);

        // Видаляємо після анімації
        ripple.addEventListener('animationend', function() {
            ripple.remove();
        });
    }
};
